module.exports = __webpack_public_path__ + "img/doll.be5030ca.webp";